Ext.define('SA.TableSection', {
    tpl: [
        '<div class="sa-table-section-scroller">',
            '<table class="sa-table-section-table"></table>',
            '<div class="sa-table-section-intrinsic-size"></div>',
        '</div>'
    ],

    constructor({cellsCache, el}) {
        var getEl = suffix => this.el.querySelector(`.sa-table-section-${suffix}`);

        this.cellsCache = cellsCache;

        this.el = el;
        this.el.innerHTML = this.tpl.join('');
        this.tableEl = getEl('table');
        this.intrinsicSizeEl = getEl('intrinsic-size');

        this.table = new SA.BasicTable({el: this.tableEl});
        this.scroller = new SA.Scroller({el: getEl('scroller'), onUserScroll: this.onUserScroll.bind(this)});

        if (this.isLeft() || this.isTop()) {
            this.preventScrollOrHideScrollbar();
        }
    },

    getBox() {
        return Ext.util.Region.getRegion(this.el);
    },

    getCells() {
        return this.cellsCache.getCells();
    },

    getScrollability() {
        return this.scroller.getScrollability();
    },

    getScrollLeft() {
        return this.scroller.getLeft();
    },

    getScrollTop() {
        return this.scroller.getTop();
    },

    isLeft() {
        return this.self === SA.TableLeftSection;
    },

    isTop() {
        return this.self === SA.TableTopSection;
    },

    onUserScroll() {
        this.el.dispatchEvent(new CustomEvent('section:userscroll', {bubbles: true, detail: {section: this}}));
    },

    preventScrollOrHideScrollbar() {
        var systemHasEphemeralScrollbars = Ext.getScrollbarSize().height === 0, 
            cls = systemHasEphemeralScrollbars ? 'sa-table-section-prevent-scroll' : 'sa-table-section-hide-scrollbar';

        this.el.classList.add(cls);
    },

    scrollBy(xDelta, yDelta) {
        this.scroller.scrollBy(xDelta, yDelta);
    },

    setContainerSize(containerSize) {
        Ext.fly(this.el).setSize(containerSize);

        this.setScrollerSizeForContainerSize({containerSize});
    },

    setFrameOffset({top, left}) {
        this.tableEl.style.margin = `${top}px 0 0 ${left}px`;
    },

    setIntrinsicSize(intrinsicSize) {
        this.scroller.constrainScrollPositionToIntrinsicSize(intrinsicSize);

        Ext.fly(this.intrinsicSizeEl).setSize(intrinsicSize);
    },

    setRowAndColumnCount(size) {
        this.table.setRowAndColumnCount(size);

        this.cellsCache.purgeStaleEntries();
    },

    setScrollLeft(scrollLeft) {
        this.scroller.setLeft(scrollLeft);
    },

    setScrollTop(scrollTop) {
        this.scroller.setTop(scrollTop);
    }
});